import type { IconName } from "@assetwatch/ui";
import { Card, Icon, Stack, Text, Title } from "@assetwatch/ui";
import type { ReactNode } from "react";

type MarketplaceCardProps = {
  title: string;
  type: string;
  description: string;
  icon: IconName;
  headerAccessory?: ReactNode;
  children?: ReactNode;
  onClick: () => void;
};

export function MarketplaceCard({
  title,
  type,
  description,
  icon,
  headerAccessory,
  children,
  onClick,
}: MarketplaceCardProps) {
  return (
    <Card fillHeight padding="comfortable" onClick={onClick}>
      <Stack gap={16} fullWidth>
        <div className="flex items-start justify-between gap-(--spacing-12)">
          <div className="flex min-w-0 flex-1 items-start gap-(--spacing-8)">
            <div className="flex size-(--spacing-48) shrink-0 items-center justify-center rounded-(--radius-sm) bg-chip-informative-container">
              <Icon name={icon} size="lg" tone="informative" aria-hidden />
            </div>
            <Stack gap={4} fullWidth>
              <div className="flex w-full items-center justify-between gap-(--spacing-8)">
                <Text size="sm" tone="subtle" weight="semibold" italic={false}>
                  {type}
                </Text>
                {headerAccessory ? (
                  <div className="shrink-0">{headerAccessory}</div>
                ) : null}
              </div>
              <Title as="h3" size="sm">
                {title}
              </Title>
            </Stack>
          </div>
        </div>
        <Text tone="subtle">{description}</Text>
        {children}
      </Stack>
    </Card>
  );
}
